import type { FecImportWizardStep } from '../hooks/useFecImportSession'

export type FecImportTrackingStep = 'finalise' | 'success' | Exclude<FecImportWizardStep, 'load-error' | 'restoring'>

interface GetFecImportTrackingStepParams {
  isFinalisingMappings: boolean
  isMappingsConfirmed: boolean
  isOrganizationFeatureLoading: boolean
  step: FecImportWizardStep
}

/** The screen the user is on, or undefined while the wizard is only loading or showing a load error. */
export const getFecImportTrackingStep = ({
  isFinalisingMappings,
  isMappingsConfirmed,
  isOrganizationFeatureLoading,
  step,
}: GetFecImportTrackingStepParams): FecImportTrackingStep | undefined => {
  if (isOrganizationFeatureLoading) {
    return undefined
  }

  if (isMappingsConfirmed) {
    return 'success'
  }

  if (step === 'restoring' || step === 'load-error') {
    return undefined
  }

  return isFinalisingMappings ? 'finalise' : step
}
